/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export const CSS = {
    title: "title",
    close: "close",
    imageContainer: "image-container",
    chipIcon: "chip-icon",
    textSlotted: "text--slotted",
    container: "container",
    imageSlotted: "image--slotted",
    closable: "closable",
    multiple: "multiple",
    single: "single",
    selectable: "selectable",
    selectIcon: "select-icon",
    selectIconActive: "select-icon--active",
    nonInteractive: "non-interactive",
    isCircle: "is-circle",
    selected: "selected",
};
export const SLOTS = {
    image: "image",
};
export const ICONS = {
    close: "x",
    checkedSingle: "circle-f",
    uncheckedMultiple: "square",
    checkedMultiple: "check-square-f",
};
//# sourceMappingURL=resources.js.map
